import { Spin, Upload } from "antd";
import CameraIcon from "../../../../../assets/icons/CameraIcon";
import UserImg from "../../../../../assets/images/avatar.svg";
import useUpload from "../../../../../hooks/useUpload";

const accept = ".png,.jpg,.jpeg";

export default function UploadProfileImage({
  isLoading,
  img,
  handleImage,
}: {
  isLoading?: boolean;
  img?: string | null;
  handleImage: (file: FormData) => void;
}) {
  const { handleUpload, handleChange, fileList } = useUpload({
    handler: handleImage,
    accept,
    // fileSize: 1,
  });

  return (
    <div className="w-24 h-24 relative select-none">
      {isLoading ? (
        <div
          className="w-full h-full rounded-full bg-cover bg-no-repeat opacity-30"
          style={{ backgroundImage: `url(${img || UserImg})` }}
        >
          <Spin className="w-full py-8" size="default">
            <span />
          </Spin>
        </div>
      ) : (
        <img
          className="w-full h-full rounded-full"
          src={img || UserImg}
          alt=""
        />
      )}

      <Upload
        name="photo"
        beforeUpload={handleUpload}
        maxCount={1}
        accept={accept}
        showUploadList={false}
        onChange={handleChange}
        fileList={fileList}
        className="h-full block py-1.5"
        disabled={isLoading}
      >
        <div
          className="w-[22px] h-[22px] right-0 top-[72px] absolute bg-[#f2f6fa] rounded-full border border-white inline-flex justify-center items-center select-none text-body-text cursor-pointer"
          // onClick={onClick}
        >
          <CameraIcon />
        </div>
      </Upload>
    </div>
  );
}
